import { EquipmentStateAllDonutChart } from '@frontend/chart/components';
import { EquipmentStateName } from '@frontend/equipment/types';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLendingEquipmentStateDonutChart } from './use-lending-equipment-state-donut-chart';

export interface LendingEquipmentStateDonutChartProps {
    accountId: string;
}

export const LendingEquipmentStateDonutChart = (props: LendingEquipmentStateDonutChartProps) => {
    const viewProps = useLendingEquipmentStateDonutChart(props);

    return (
        <StatisticsCard
            chartKey={EquipmentStateAllDonutChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.lending.equipments-by-status.title'
                    description='Title of the lending dashboard chart showing equipment counts grouped by status'
                    defaultMessage='Equipments by status'
                />
            }
            isLoading={viewProps.isLoading}
            hasData={!!viewProps.data}>
            {viewProps.data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <EquipmentStateAllDonutChart
                        data={viewProps.data}
                        minHeight={80}
                        onSliceClick={(label) => viewProps.navigate(viewProps.getNavigateTarget(label as EquipmentStateName))}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
